export interface ITargetThreshold {
    target: number;
    low: number;
    high: number;
    enabled: boolean;
}

export const compareTargetThreshold = (
    a: ITargetThreshold,
    b: ITargetThreshold,
): boolean => {
    return (
        a.low !== b.low ||
        a.high !== b.high ||
        a.target !== b.target ||
        a.enabled !== b.enabled
    );
};
